module.exports = __webpack_public_path__ + "static/img/wxpay.75745dba.png";